import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api-client';
import type { InvoiceRow } from '../types';

export interface BlOrderInvoices {
  payable: InvoiceRow[];
  receivable: InvoiceRow[];
}

export function blOrderInvoicesKey(blOrderId: string | undefined) {
  return ['bl-order-invoices', blOrderId] as const;
}

export function useBlOrderInvoices(blOrderId: string | undefined) {
  return useQuery<BlOrderInvoices>({
    queryKey: blOrderInvoicesKey(blOrderId),
    enabled: blOrderId !== undefined && blOrderId.length > 0,
    queryFn: () =>
      apiRequest<BlOrderInvoices>(`/bl-orders/${encodeURIComponent(blOrderId ?? '')}/invoices`),
  });
}
